import styled from "styled-components";
import {OnboardingDialogLogoDefaultBox} from "./onboarding-dialog-logo.default.box";

export const OnboardingDialogLogoCasino777Box = styled(OnboardingDialogLogoDefaultBox)`
    border: 0.8rem solid ${({theme}) => theme.colors.backgroundActive};
`;